// src/utils/pkce.ts

// Generate the code verifier (random string)
export const generateCodeVerifier = () => {
    const array = new Uint8Array(56); // Using Uint8Array for 56 random bytes
    window.crypto.getRandomValues(array); // Get cryptographically secure random values
    return base64UrlEncode(array); // Convert to base64 URL-safe string
  };
  
  // Generate the code challenge (SHA-256 hash of the code verifier)
  export const generateCodeChallenge = async (codeVerifier: string) => {
    const buffer = new TextEncoder().encode(codeVerifier); // Encode the verifier to a byte array
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', buffer); // Hash the verifier
    return base64UrlEncode(new Uint8Array(hashBuffer)); // Convert the hash to base64 URL-safe string
  };
  
  // Helper function to convert a byte array to a Base64 URL-safe string
  const base64UrlEncode = (array: Uint8Array) => {
    const base64 = btoa(String.fromCharCode(...array)); // Convert array to base64 string
    return base64
      .replace(/\+/g, '-') // Replace '+' with '-'
      .replace(/\//g, '_') // Replace '/' with '_'
      .replace(/=+$/, ''); // Remove padding (optional)
  };
  